<template lang="pug">
.field-modal-select-multiple
	.field-modal-select-multiple__header
		h4.field-modal-select-multiple__title {{ `${field.prefix ? field.prefix : ''} ${field.title ? field.title : ''} ${field.postfix ? field.postfix : ''}` }}
		.field-modal-select__tabs(v-if="field.tabs")
			button.btn--primary-whit.view-picker__item(v-for="(tab, index) in field.tabs"
				:key="index"
				@click="setActiveTab(tab.tabId)"
				:class="{'view-picker__item--active': tab.tabId === activeId}")
				v-svg-icon.view-picker__icon(:icon="tab.icon")
				span.view-picker__text {{ tab.text }}
	.field-check-list__items(v-if="activeId === 'list'" data-scroll-lock-scrollable)
		.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
			template(v-if="option.all" )
				label.field-select__list-item.field-select__list-item--flex(:class="option?.className")
					input.field-select__input(
						type="checkbox"
						:id="uniqueId + index"
						v-model="selectAll"
						@change="all"
						:disabled="field.disabled || option.disabled")
					.field-checkbox__visual
					span.field-checkbox__text {{option.text}}
			template(v-else )
				label.field-select__list-item.field-select__list-item--flex(:for="uniqueId + index" :class="option?.className")
					input.field-select__input(
						type="checkbox"
						:id="uniqueId + index"
						:value="option.value"
						v-model="localValue"
						:disabled="field.disabled || option.disabled")
					.field-checkbox__visual
					span.field-checkbox__text {{option.text}}
	.field-check-list__map(v-if="activeId === 'map'" )
		v-map-filter(:initParams="field.map" @drawing-area="drawingArea")
	.field-check-list__buttons(v-if="field.buttons")
		button.field-check-list__button.btn.btn--white.btn--round(v-for="(button, index) in field.buttons"
			:key="index"
			:class="button.className"
			@click="handleInput")
			| {{ button.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
import uniqueId from "../scripts/helpers/uniqueId.js";

export default {
	mixins: [sourceMixin],

	props: {
		modelValue: {
			type: [Object, String, Number],
			default: null
		},

		modelSelectAll: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'update:model-value',
		'change-select',
		'change-select-all',
		'select-all',
		'map-filter-changed'
	],

	data() {
		return {
			field: null,
			localValue: null,
			uniqueId: uniqueId('field-'),
			selectAll: null,
			activeId: null,
			aria: null
		};
	},

	methods: {
		dataSet(data) {
			this.field = data;
			this.activeId = this.field?.tabs.find(tab => tab.active === true).tabId || null
		},

		setActiveTab(id) {
			this.activeId = id
		},

		drawingArea(path) {
			console.log(path)
			this.aria = path
			// this.dataLoad({
			// 	url: this.catalog.remote,
			// 	delay: true,
			// 	data: {
			// 		filter: this.state.filter,
			// 		mapFilter: path,
			// 	}
			// });
		},

		handleInput() {
			if (this.activeId === 'map') {
				// this.$emit('update:model-value', this.aria);
				this.$emit('map-filter-changed', this.aria);
				// this.dataLoad({
				// 	url: "",
				// 	delay: true,
				// 	data: {
				// 		mapFilter: this.aria,
				// 	}
				// });
			} else if (this.activeId === 'list'){
				if(this.selectAll) {
					this.$emit('update:model-value', 'select-all');
				} else {
					this.$emit('update:model-value', this.localValue.filter(value => value !== 'select-all'));
				}
			}

			controller.closeModal()
		},

		all() {
			if(this.selectAll) {
				this.localValue = this.field.options.map(option => option.value)
				this.$emit('change-select', this.localValue);
				this.$emit('change-select-all', this.selectAll);
			} else {
				this.localValue = [];
				this.$emit('change-select', this.localValue);
				this.$emit('change-select-all', this.selectAll);
			}
		},
	},

	watch: {
		localValue() {
			if(this.localValue.find(value => value === 'select-all')) {
				this.localValue.length === this.field.options.length ? this.selectAll = true : this.selectAll = false;
			} else {
				this.localValue.length + 1 === this.field.options.length ? this.selectAll = true : this.selectAll = false;
			}

			this.$emit('change-select', this.localValue);
			this.$emit('change-select-all', this.selectAll);
		},


		// localValue() {
		// 	console.log('change-selectc')
		// 	this.$emit('change-select', this.localValue);
		// },



	},

	created() {
		this.localValue = this.modelValue;
		this.selectAll = this.modelSelectAll;
		if(this.selectAll) {
			this.localValue = this.field.options.map(option => option.value)
			this.$emit('change-select', this.localValue);
			this.$emit('change-select-all', this.selectAll);
		}
	},

}

</script>